import Main from './Main'
import Lista from './components/BancoNotificacao'
import Novo from './components/NovoBancoNotificacao'

export default [
  {
    path: 'banco-notificacao',
    name: 'config.banco-notificacao',
    component: Main,
    redirect: { name: 'config.banconotificacao.list' },
    children: [
      {
        path: '/',
        name: 'config.banconotificacao.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'config.banconotificacao.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'config.banconotificacao.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/configuracoes/banco-notificacao/routes.js